import React from 'react';

interface RenderHeadingProps {
    label: string;
}

export const RenderHeading: React.FC<RenderHeadingProps> = ({ label }) => {
    return (
        <>
            <div className="clearfix" />
            <h2 className="heading-section-title">{label}</h2>
        </>
    );
};